<!-- 取样值Swiper的形式 -->
<template>
  <div class="uk-position-relative r-default" style="overflow: visible;">
    <div
      class="arrow arrow-left triangle cursor-pointer"
      @click="$refs.caro.prev()"
      v-if="sample.length > 1"
    ></div>
    <el-carousel
      height="50px"
      :autoplay="false"
      arrow="never"
      indicator-position="none"
      ref="caro"
    >
      <el-carousel-item v-for="(item, index) in sample" :key="index">
        <div class="border-box range-item r-default" style="overflow: hidden;">
          <div class="range-tag uk-flex">
            <div
              style="white-space: nowrap;width: 90%;text-overflow: ellipsis;"
            >
              <span v-if="item.isRange === 1">
                <span v-if="item.code === 'temp'">
                  {{ $t('integration.temperature_range_without_monitoring') }}
                </span>
                <span v-else-if="item.code === 'hum'">{{
                  $t('integration.unrelated_humidity_range')
                }}</span>
              </span>
              <span v-else>
                {{
                    `${formatTempValue(item.min,unit[item.code].name)}${unit[item.code].name}~${formatTempValue(item.max,unit[item.code].name)}${
                      unit[item.code].name
                    }`
                }}
              </span>
            </div>
            <span class="w-10 bd-l">
              <!-- info图表 -->
              <div
                class="color-white w-100"
                :class="{ 'bg-red': !item.status }"
              >
                <el-popover
                  placement="right-end"
                  width="300"
                  trigger="hover"
                  @show="activeIndex = index"
                  @hide="activeIndex = null"
                >
                  <SampleValue
                    v-if="activeIndex === index"
                    :key="index + '-' + Date.now()"
                    :sample_value="JSON.stringify({ [item.code]: [item] })"
                    :scopeName="$attrs.scopeName"
                    :carrierId="$attrs.carrierId"
                    :carrierName="$attrs.carrierName || $attrs.keycode"
                    :typeId="$attrs.typeId"
                    :carrierInfo="$attrs.carrierInfo"
                  />
                  <template #reference>
                    <i
                      class="el-icon-info cursor-pointer"
                    ></i>
                  </template>
                </el-popover>
              </div>
            </span>
          </div>
          <div class="uk-flex bd-l bd-r bd-b">
            <!-- 时间 -->
            <div class="time uk-flex-1 border-right">
              {{ $timetransition(item.time) }}
            </div>
            <!-- 值 -->
            <div
              class="val uk-text-center"
              v-range="[item.val, item, 'background']"
            >
              {{ parseVal(item) }}
            </div>
            <div class="w-10 bd-l uk-text-center driver-item-chart">
              <i
                class="iconfont icon-zhexiantu cursor-pointer "
                style="font-size: 14px;"
                :title="$t('integration.monitoring_point_chart')"
                @click="toSampleChart"
              ></i>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>

    <div
      class="arrow arrow-right triangle cursor-pointer"
      @click="$refs.caro.next()"
      v-if="sample.length > 1"
    ></div>
  </div>
</template>

<script>
import { defaultUnit } from '@/utils/convert'
import SampleValue from '@/components/SampleValue/SampleValue'
import { carrierProbeHistory, transportHistory } from '@/utils/winDetail'
import { TempUtils } from '@/utils/TempUtil.js';
export default {
  props: {
    sample: {},
    parseVal: {
      type: Function
    }
  },
  provide() {
    return {
      sampleData: this.currentSampleData
    }
  },
  components: {
    SampleValue
  },
  watch: {
    sample () {
      this.sample.forEach(item => {
        this.$set(
          item,
          'status',
          item.itemMap.every(item => item.status === 1) ? 1 : 0
        )
      })
    }
  },
  data () {
    return {
      defaultUnit,
      activeIndex: null
    }
  },
  methods: {
    formatTempValue(val,code) {
      if (val === null || val === undefined || val === '') return '--'
      const numVal = Number(val)
      if (isNaN(numVal)) return '--'

      const result = TempUtils.convertToCelsius(numVal, code);
      return `${result}`
    },
    toSampleChart () {
      // const carrierInfoBrief = getCarrierInfoBrief(this.$attrs.carrierInfo);
      switch (this.$attrs.carrierInfo.mode) {
        case 1:
          carrierProbeHistory({
            carrierInfo: this.$attrs.carrierInfo
          })
          break
        case 2:
          transportHistory({
            carrierInfo: this.$attrs.carrierInfo
          })
          break
      }
    }
  }
}
</script>
<style scoped lang="scss">
$triangle-size: 8px;

.arrow {
  position: absolute;
  margin-top: 15px;

  top: 0;
}

.arrow-right {
  right: -17px;

  border-color: transparent transparent transparent var(--primary-color);
}

.arrow-left {
  left: -17px;
  border-color: transparent var(--primary-color) transparent transparent;
}

.triangle {
  border-style: solid;
  border-width: $triangle-size;
}
</style>
